/* Layout only: never alters product data, review content, links or buying controls. */
(() => {
  if (window.mmsCardRowsLoaded) return;
  window.mmsCardRowsLoaded = true;
  const tracks = {
    title: ':scope > .card__heading',
    rating: ':scope > .Vtl-CollectionCardWidget, :scope > .card-information > .mms-native-card-rating-group',
    inspiration: ':scope > .mms-oil-inspiration',
    preorder: ':scope > .mms-card-preorder',
    fit: ':scope > .card-information > .mms-diffuser-card-fit',
    price: ':scope > .card-information > .price'
  };
  const grids = new Map();
  let frame = 0;
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  function outerHeight(element) {
    if (!element.getClientRects().length) return 0;
    const style = getComputedStyle(element);
    return element.getBoundingClientRect().height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
  }
  function update() {
    frame = 0;
    grids.forEach((state, grid) => {
      if (!grid.isConnected) {
        state.resize?.disconnect();
        state.mutation.disconnect();
        grids.delete(grid);
        return;
      }
      const rows = [];
      [...grid.children].forEach(item => {
        const info = item.querySelector('.card > .card__content > .card__information');
        if (!info || !item.getClientRects().length) return;
        const top = item.offsetTop;
        let row = rows.find(candidate => Math.abs(candidate.top - top) < 3);
        if (!row) rows.push(row = { top, cards: [] });
        row.cards.push(info);
        // Observe natural content sizes, not our stretched grid tracks.
        Object.values(tracks).forEach(selector => info.querySelectorAll(selector).forEach(el => state.resize?.observe(el)));
      });
      rows.forEach(row => {
        const sizes = row.cards.map(info => Object.fromEntries(
          Object.entries(tracks).map(([track, selector]) => [track, Math.ceil(Math.max(0, ...[...info.querySelectorAll(selector)].map(outerHeight)))])
        ));
        const maxHeader = Math.max(0, ...sizes.map(size => size.title + size.rating));
        const maxima = Object.fromEntries(Object.keys(tracks).map(track => [track, Math.max(0, ...sizes.map(size => size[track]))]));
        row.cards.forEach((info, index) => {
          Object.keys(tracks).forEach(track => {
            // Keep title/review adjacent; move balancing room below their pair.
            const height = track === 'title' || track === 'rating' ? sizes[index][track]
              : track === 'inspiration' ? maxima.inspiration + maxHeader - sizes[index].title - sizes[index].rating
              : maxima[track];
            const property = `--mms-${track}-row`;
            const value = `${height}px`;
            if (info.style.getPropertyValue(property) !== value) info.style.setProperty(property, value);
          });
        });
      });
    });
  }
  function discover() {
    document.querySelectorAll('[data-mms-card-rows]').forEach(grid => {
      if (grids.has(grid)) return;
      const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
      const mutation = new MutationObserver(schedule);
      // App hydration may add stars or change text/classes. Ignore style writes.
      mutation.observe(grid, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
      resize?.observe(grid);
      grids.set(grid, { resize, mutation });
    });
    schedule();
  }
  // Faceted collection rendering replaces the grid; theme editor replaces sections.
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-mms-card-rows]') || node.querySelector?.('[data-mms-card-rows]'))))) discover();
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', discover);
  document.fonts?.ready.then(schedule);
  discover();
})();
